import React from "react";
import ReactPaginate from "react-paginate";
import { Icon } from "../../components";

const Pagination = ({
  currentPage,
  recordsPage,
  dataLength,
  handlePagination,
  showPageInfo = true,
}) => {
  const lastIndex = currentPage * recordsPage;
  const pageCount = Math.ceil(dataLength / recordsPage) || 1;

  return (
    <div className="d-flex flex-md-row flex-column align-items-md-center align-items-start justify-content-md-between justify-content-md-end">
      {showPageInfo ? (
        <div className="pagination_info ps-2">
          Showing {lastIndex - recordsPage + 1} to{" "}
          {dataLength < lastIndex ? dataLength : lastIndex} of {dataLength}{" "}
          records
        </div>
      ) : (
        <div className="pagination_info ps-2"></div>
      )}
      <div className="dataTables_paginate paging_simple_numbers px-2">
        <ReactPaginate
          previousLabel={<Icon name="chevron-left" />}
          nextLabel={<Icon name="chevron-right" />}
          pageCount={pageCount}
          forcePage={currentPage - 1}
          onPageChange={(selectedItem) => handlePagination(selectedItem)}
          pageClassName={"page-item"}
          pageRangeDisplayed={3}
          nextLinkClassName={"page-link"}
          nextClassName={"page-item next"}
          previousClassName={"page-item prev me-1"}
          previousLinkClassName={"page-link"}
          pageLinkClassName={"page-link paginate-page-link me-1"}
          containerClassName={
            "pagination pagination-sm react-paginate justify-content-end my-2"
          }
          activeClassName="active"
        />
      </div>
    </div>
  );
};

export default Pagination;
